<template>
  <div class="services">
    <div v-for="(service, serviceIndex) in services"
         :key="`service-${serviceIndex}`"
         class="service"
         :class="activeServiceIndex === serviceIndex && viewport.xs ? 'is-active' : ''">
        <div class="service__title" @click="() => handleItemClick(serviceIndex)">
          {{service.title}}
        </div>
        <div class="service__items"
             ref="servicesRef"
             :style="{
                        maxHeight: activeServiceIndex === serviceIndex ?
                                   `${service.maxHeight}px` : '0'
                     }">
          <div v-for="(item, itemIndex) in service.items"
               :key="`service-item-${itemIndex}`"
               class="service__item">
              {{item}}
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Services',
  data() {
    return {
      services: [
        {
          title: 'Strategy',
          items: [
            'Research',
            'UI/UX audit',
            'Stakeholder workshops',
            'Product strategy',
            'Innovation consulting',
          ],
        },
        {
          title: 'Design',
          items: [
            'UI/UX design',
            'Brand identity',
            'Websites and mobile apps',
            'Visual design',
            'Prototyping and testing',
          ],
        },
        {
          title: 'Development',
          items: [
            'HTML/CSS/JS',
            'React/Angular',
            'Backend/API integrations',
            'iOS/Android native apps',
            'Rapid prototyping',
          ],
        },
        {
          title: 'Content',
          items: [
            'Copywriting',
            'Video',
            'Animation',
            'Iconography',
            '2D/3D graphics',
          ],
        },
      ],
      activeServiceIndex: 0,
      autoSwitchInterval: undefined,
      autoSwitchTimeout: undefined,
    };
  },
  computed: {
    ...mapState('viewport', ['viewport']),
  },
  mounted() {
    const { calculateMenusMaxHeight, enableAutoSwitch, viewport } = this;
    if (viewport.xs) {
      calculateMenusMaxHeight();
      enableAutoSwitch();
    } else {
      this.resetMenusMaxHeights();
    }
  },
  beforeDestroy() {
    this.clearIntervals();
  },
  watch: {
    viewport(viewport) {
      const {
        clearIntervals, resetMenusMaxHeights, calculateMenusMaxHeight, enableAutoSwitch,
      } = this;
      clearIntervals();
      if (viewport.gt.xs) {
        resetMenusMaxHeights();
      } else {
        calculateMenusMaxHeight();
        enableAutoSwitch();
      }
    },
  },
  methods: {
    calculateMenusMaxHeight() {
      const { $refs: { servicesRef }, services, activeServiceIndex } = this;

      const maxHeights = [];
      /* eslint-disable */
      servicesRef.forEach((menu, menuIndex) => {
        menu.style.maxHeight = 'none';
        maxHeights.push(menu.offsetHeight);
        if(menuIndex === activeServiceIndex){
          return;
        }
        menu.style.maxHeight = '0';
      });
      /* eslint-enable */

      this.services = services.map(service => ({
        ...service,
        maxHeight: maxHeights.shift(),
      }));
    },
    enableAutoSwitch() {
      this.autoSwitchInterval = setInterval(() => {
        this.activeServiceIndex = this.activeServiceIndex === this.services.length - 1
          ? 0 : this.activeServiceIndex + 1;
      }, 3000);
    },
    clearIntervals() {
      clearInterval(this.autoSwitchInterval);
      clearTimeout(this.autoSwitchTimeout);
    },
    handleItemClick(index) {
      const { clearIntervals, enableAutoSwitch, viewport } = this;
      if (viewport.gt.xs) {
        return;
      }
      clearIntervals();
      this.activeServiceIndex = index;
      this.autoSwitchTimeout = setTimeout(enableAutoSwitch, 6000);
    },
    resetMenusMaxHeights() {
      const { $refs: { servicesRef } } = this;
      servicesRef.forEach((menu) => {
        // eslint-disable-next-line
        menu.style.maxHeight = 'none';
      });
    },
  },

};
</script>

<style scoped lang="stylus">
  @import '../../styles/variables';
  .services{
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .service{
    margin-bottom: 25px;

    &:last-child{
      margin-bottom: 0;
    }
    &.is-active{
      .service__title{
        color: #4CB06A;
      }
    }
  }
  .service__title, .service__item{
    text-align: center;
  }
  .service__title{
    font-family: 'Dosis', sans-serif;
    font-weight: 600;
    font-size: 25px;
    transition: color 0.3s;
    cursor: pointer;
  }
  .service__items{
    overflow: hidden;
    transition: max-height 0.6s;
  }

  .service__item{
    font-size: 14px;
    font-weight: 300;
    padding-bottom: 20px;
    line-height: 20px;

    &:first-child{
      padding-top: 25px;
    }
    &:last-child{
      padding-bottom: 0;
    }
  }
  @media(min-width: $breakpoint-sm-min){
    .service__title{
      cursor: auto;
    }
    .services{
      display: flex;
      flex-wrap: wrap;
      max-width: 450px;
      margin: 0 auto;
      padding-top: 125px;
      padding-bottom: 30px;
    }
    .service{
      flex-basis: 50%;
      padding-bottom: 85px;
      margin-bottom: 0;

      &:nth-child(even){
        padding-left: 55px;
      }
    }
    .service__title, .service__item{
      text-align: left;
    }
    .service__item{
      padding-bottom: 40px;
      font-size: 16px;
      &:first-child{
        padding-top: 40px;
      }
    }
  }

  @media(min-width: $breakpoint-md-min){
    .services{
      max-width: 1050px;
    }
    .service{
      flex-basis: 0;
      flex-grow: 1;
      &:nth-child(even){
        padding-left: 0;
      }
    }
  }

  @media(min-width: $breakpoint-lg-min) {
    .services{
      max-width: 1360px;
      padding-top: 195px;
      padding-bottom: 95px;
    }
    .service__title{
      font-size: 30px;
    }
    .service__item{
      padding-bottom: 50px;
      font-size: 18px;
      line-height: 23px;
      &:first-child{
        padding-top: 50px;
      }
    }
  }
</style>
